import { useCallback, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { slugSplitter } from "../../utils/slugManager";
import { useTranslation } from "react-i18next";
import config from "../../configuration/config";
import { groupBy, mapValues, omit } from "lodash";
import _ from "lodash";
import { CarCheckoutSignAgreementPage } from "./carCheckoutSignAgreement";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import { useHistory } from "react-router";
import ConfirmContext from "../../utils/confirmContext";
export function CarSalesOrder() {
  const { orderGuid, page } = useParams();
  const thisConfirmContext = useContext(ConfirmContext);
  const { t: trans, i18n } = useTranslation(["new", "finance", "inputs", "info", "new"]);
  const [activePart, setActivePart] = useState(0);
  const history = useHistory();
  const [Cart, setCart] = useState({
    Id: "",
    colorID: "",
    colorNameEn: "",
    modelTypeDescEn: "",
    groupEn: "",
    brandEn: "",
    modelTypeDesc: "",
    Price: 0,
    Discount: 0,
    Tax: 0,
    ProductID: "",
    colorName: "",
    group: "",
    brand: "",
    year: "",
    modelType: "",
    showPric: false,
    BrandID: "",
    MiniDownPayment: 0,
  });

  let lang = i18n.language || "ar";
  const [isLoading, setIsLoading] = useState(true);
  const [salesOrder, setSalesOrder] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(false);

  const [activeModel, setActiveModel] = useState("");

  const [activeINColor, setActiveINColor] = useState("");
  const [activeOutColor, setActiveOutColor] = useState("");
  const [vehicle, setVehicle] = useState(null);
  const [models, setModels] = useState([]);
  // const [activeModel, setActiveModels] = useState({});

  const [colors, setCarColors] = useState([]);
  const [innerCarImages, setInnerCarImages] = useState([]);
  const [outerCarImages, setOuterCarImages] = useState([]);
  const [wheels, setWheels] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [cashColors, setCashColors] = useState({});
  const handelSetPersonalData = useCallback(() => {
    // You can await here
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const userData = JSON.parse(getData(User_Data_Key, true));
    } else {
      history.push({
        pathname: `/carSO/registration/${orderGuid}`,
        search: `?redirect=/carSO/signAgreement/${orderGuid}`,
      });
      thisConfirmContext.onShowRegistrationPup(true);
    }

    // ...
  }, []);
  useEffect(() => {
    handelSetPersonalData();
  }, []);

  useEffect(() => {
    if (selectedColor) {
      const selectdM = models?.find((item) => item?.Type == selectedColor?.Type) ?? null;

      try {
        const currentValues = { ...Cart };
        currentValues.Id = selectedColor?.GUID;
        currentValues.brand = selectedColor["Brand Arabic"];
        currentValues.brandEn = selectedColor["Brand English"];
        currentValues.group = selectedColor["Group Arabic"];
        currentValues.groupEn = selectedColor["Group English"];
        currentValues.colorName = selectedColor["ColorDescriptionAr"];
        currentValues.colorNameEn = selectedColor["ColorDescriptionEn"];
        currentValues.colorID = selectedColor?.ColorID;
        currentValues.Price = selectedColor?.NetSalePrice;
        currentValues.Tax = selectedColor?.TaxAmount;
        currentValues.Discount = selectedColor?.Discount;
        currentValues.ProductID = selectedColor?.ProductID;
        currentValues.BrandID = selectedColor?.BrandID;
        currentValues.image = selectdM?.Image ?? (filterCarImages && filterCarImages[0]?.Image_URL);
        currentValues.modelType = selectedColor?.Type;
        currentValues.modelTypeDesc = selectedColor["Type Arabic"];
        currentValues.modelTypeDescEn = selectedColor["Type English"];
        currentValues.showPric = selectedColor?.showPric;
        currentValues.year = selectedColor?.Model;
        currentValues.MiniDownPayment = selectedColor.MiniDownPayment;
        currentValues.SN = selectedColor.SN;
        currentValues.Slug = selectedColor.ProductTarget;
        //console.log("useEffect Cart:", currentValues);
        setCart(currentValues);
      } catch (err) {
        ////console.log(err);
      }
    }
  }, [selectedColor]);

  useEffect(() => {
    if (orderGuid) {
      FetchSalesOrderTransCarByGUID(orderGuid);
    }
  }, [orderGuid]);
  useEffect(() => {
    if (salesOrder.SN && salesOrder.Slug) callback();
  }, [salesOrder]);

  const [banks, setBanks] = useState([]);

  const [financeSettings, setFinanceSettings] = useState(null);
  const [finance, setFinance] = useState({ price: 0, month: 0, first: 0, last: 0, totalPrice: 0 });
  const [minFinance, setMinFinance] = useState({ price: 0, month: 0, first: 0, last: 0, totalPrice: 0 });

  useEffect(() => {
    if (finance.price && finance.price > 0 && (minFinance.price == null || minFinance.price == 0)) {
      setMinFinance(finance);
    }
  }, [finance, minFinance]);
  useEffect(() => {
    if (banks?.length > 0) {
      const minBank = banks.reduce((min, bank) => {
        const currentValue = bank.FinanceRate + bank.ManagementFees;
        const minValue = min.FinanceRate + min.ManagementFees;
        return currentValue < minValue ? bank : min;
      }, banks[0]);

      setFinanceSettings(minBank);
    }
  }, [banks]);

  const [isToyota, setisToyota] = useState(false);
  const [isLexus, setisLexus] = useState(false);
  useEffect(() => {
    if (vehicle) {
      setisToyota(vehicle?.brand && (vehicle?.brand.toLowerCase() === "تويوتا" || vehicle?.brand.toLowerCase() === "toyota"));
      setisLexus(vehicle?.brand && (vehicle?.brand.toLowerCase() === "لكزس" || vehicle?.brand.toLowerCase() === "lexus"));
    }
  }, [vehicle]);

  useEffect(() => {
    if (vehicle?.colorID && vehicle?.colorID?.split("/")[0] && vehicle?.colorID?.split("/")[1]) {
      setActiveOutColor(vehicle?.colorID?.split("/")[0]);
      setActiveINColor(vehicle?.colorID?.split("/")[1]);
    }
  }, [vehicle]);

  const handleFetchModelAvaliableColors = async (productTypeID, currentColorID, year, thisSelectedColorID = selectedColor?.ColorID) => {
    let _colors = [];

    try {
      if (cashColors[productTypeID]) {
        _colors = cashColors[productTypeID];
        setCarColors(_colors);
        let _default = null;

        if (selectedColor?.ColorID || currentColorID) {
          _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === currentColorID);
        } else {
          _default = _colors.find((item) => item.buyOnline == true);
          if (!_default) _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === currentColorID);
        }

        ////console.log("_default Color:", _default);
        setSelectedColor(_default);
      } else {
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchColorOfTypeWithOutImages`, {
          Type: productTypeID,
          model: year,
        });

        if (response.status == 200) {
          _colors = response.data?.filter((item) => item.buyOnline == 1);

          var cc = { ...cashColors };
          cc[productTypeID] = _colors;
          setCashColors(cc);

          ////console.log("site_fetchColorOfType:", response.data);

          _colors = _colors;
          setCarColors(_colors);
          let _default = null;

          _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === currentColorID);
          if (_default) {
            // filterPriceoffColor(_default);
          }

          ////console.log("_default Color:", _default);
          setSelectedColor(_default);
        }
      }
    } catch (error) {
      ////console.log(error);
    }

    return _colors;
  };

  const [cashCarImages, setCashCarImages] = useState({});
  const fetchCarDesign = async (activeColor, model, partnum = activePart) => {
    if (isLoadingImages == false && OUTcolorsCode && OUTcolorsCode?.length > 0) {
      setIsLoadingImages(true);
      setFilterCarImages([]);
      var codeColor = partnum == 0 ? activeColor?.split("/")[0] : activeColor?.split("/")[1];
      var codeColorIN = activeColor?.split("/")[1];
      var codeColorOUT = activeColor?.split("/")[0];

      var imagesPart = [];

      if (model) {
        if (cashCarImages[model + "-part-" + partnum]) {
          setIsLoadingImages(false);
          var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
          var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];

          if (AllCarImagesIN) {
            setInnerCarImages(AllCarImagesIN[codeColorIN]);
          } else {
            setInnerCarImages([]);
          }

          if (AllCarImagesOUT) {
            setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
          } else {
            setOuterCarImages([]);
          }
        } else {
          axios
            .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchCarColorCodeImages`, {
              //SiteFetchCarColorImages
              Id: model,
              year: vehicle?.year,
              // "ColorID": String(codeColor),
              ColorID: null,
              FieldNameList: null,
            })
            .then((response) => {
              setIsLoadingImages(false);
              if (Array.isArray(response.data)) {
                // ////console.log("SiteFetchCarColorCodeImages responseData>>>>>>>>>>>>>>>>>>>>>>>>>:", responseData);
                const groupResult = mapValues(groupBy(response.data, "ColorCode"), (fList) => fList.map((items) => omit(items, "ColorCode")));
                ////console.log("OUTcolorsCode ..............:", OUTcolorsCode);
                var allcolor = [...OUTcolorsCode, ...INcolorsCode];

                allcolor?.map((key) => {
                  var colorCodeItems = groupResult[key];
                  if (colorCodeItems?.length > 0) {
                    if (OUTcolorsCode?.includes(key)) {
                      var cimage = cashCarImages[model + "-part-" + 0];

                      if (!cimage) {
                        cimage = {};
                      }

                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 0] = cimage;
                      // cashCarImages[model + "-" + key + "-part-" + 0] = colorCodeItems;
                      if (codeColorOUT == key) {
                        imagesPart = colorCodeItems;
                        setOuterCarImages(colorCodeItems);
                      }
                    } else if (INcolorsCode?.includes(key)) {
                      var cimage = cashCarImages[model + "-part-" + 1];

                      if (!cimage) {
                        cimage = {};
                      }

                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 1] = cimage;
                      // cashCarImages[model + "-" + key + "-part-" + 1] = colorCodeItems;
                      if (codeColorIN == key) {
                        imagesPart = colorCodeItems;
                        setInnerCarImages(colorCodeItems);
                      }
                    } else {
                      var cimage = cashCarImages[model + "-part-" + 2];

                      if (!cimage) {
                        cimage = {};
                      }

                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 2] = cimage;

                      // cashCarImages[model + "-" + key + "-part-" + 2] = colorCodeItems;
                      if (codeColor == key) {
                        imagesPart = colorCodeItems;
                        setWheels(colorCodeItems);
                      }
                    }
                  }
                });

                ////console.log("cashCarImages>>>>>>>>>>>>>>>>>>>>>>>>>:", cashCarImages);

                const imagesCount = imagesPart?.length;

                var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
                var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];

                ////console.log("fetchCarDesign AllCarImagesIN:", AllCarImagesIN);
                ////console.log("fetchCarDesign AllCarImagesOUT:", AllCarImagesOUT);

                if (AllCarImagesIN) {
                  setInnerCarImages(AllCarImagesIN[codeColorIN]);
                } else {
                  setInnerCarImages([]);
                }

                if (AllCarImagesOUT) {
                  setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
                } else {
                  setOuterCarImages([]);
                }

                // setAllCarImages([...outerImages, ...innerImages, ...wheelsImages])
                setIsLoadingImages(false);
              }
            })
            .catch(() => {
              ////console.log(error);
              setIsLoadingImages(false);
              cashCarImages[model + "-part-" + partnum] = {};
            });
        }
      } else {
        setIsLoadingImages(false);
      }
    }
  };

  const afterChangeDataType = async (firstItem, thisSelectedColorID = selectedColor?.ColorID, partnum = activePart) => {
    setActiveOutColor("");
    setActiveINColor("");
    setSelectedColor(null);
    resetColorsValues();
    resetValues();

    const colors = await handleFetchModelAvaliableColors(firstItem?.type ?? firstItem?.Type, firstItem?.ColorID ?? firstItem?.colorID, firstItem?.year);

    var currentSelectedColor = colors?.filter((item) => item.ColorID == thisSelectedColorID)?.length > 0 ? thisSelectedColorID : firstItem?.colorID;
    try {
      if (currentSelectedColor && currentSelectedColor?.split("/")[0] && currentSelectedColor?.split("/")[1]) {
        setActiveOutColor(currentSelectedColor?.split("/")[0]);
        setActiveINColor(currentSelectedColor?.split("/")[1]);
      }
    } catch (error) {
      ////console.log(error);
    }

    if (firstItem) {
      setCarColors(colors);
      fetchCarDesign(currentSelectedColor, firstItem?.productID);
    }
  };
  async function FetchSalesOrderTransCarByGUID(guid) {
    const Body = {
      SalesOrderGUID: guid,
    };

    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FetchSalesOrderTrans_Car_ByGUID`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        const result = response?.data;
        if (result && result.length > 0) {
          var appData = result[0];
          if (appData.StatusPaymentID == "FullyPaid") {
            const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
            if (paymentMethodCallback == null) {
              // setShowFinalPopupMessage(trans("new:Prepaid"));
              // setShowFinalPopup(true);
            }
          } else if (appData.SalesInvoiceStatusID == "Canceled") {
            const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
            if (paymentMethodCallback == null) {
              // setShowFinalPopupMessage(trans("new:agreement_link_is_cancelled"));
              // setShowFinalPopup(true);
            }
          } else {
            setSalesOrder(appData);
            // الشروط والاحكام
            let dataTerms;
          }
        } else {
          // setShowFinalPopupMessage(trans("امر البيع غير موجود"));
          // setShowFinalPopup(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const callback = useCallback(async () => {
    setIsLoading(true);

    var curvehicle;
    try {
      await axios
        .request({
          baseURL: config.controllURL,
          url: config.controllURL + lang + "/api/VehicleOverview/" + null + "/" + salesOrder.Slug + "/carDetails",
          // url: lang + "/api/VehicleOverview/" + slugSplitter(brand) + "/" + slug + "/overview",
          method: "get",
        })
        .then(async function (response) {
          if (response.data.vehicle) {
            curvehicle = response.data.vehicle;
            setVehicle(response.data.vehicle);
          }

          setIsLoading(false);
        })
        .catch(function () {
          setIsLoading(false);
        });
    } catch (error) {}

    var curentCars;

    try {
      await axios
        .request({
          baseURL: "/",
          url: config.controllURL + lang + "/api/VehicleOverview/" + slugSplitter(curvehicle?.group) + "/" + curvehicle?.year + "/models",
          method: "get",
        })
        .then(async function (response) {
          curentCars = response.data.models?.filter((item) => item.buyOnline == 1);

          var _default = curvehicle;
          _default = curentCars.find((item) => item.type == curvehicle?.type) ?? curvehicle;

          if (_default) {
            setActiveModel(_default);
            afterChangeDataType(_default, true);
          }

          setModels(curentCars);
        })
        .catch(function () {
          afterChangeDataType(curvehicle, true);
        });
    } catch (error) {
      afterChangeDataType(curvehicle, true);
    }
  }, [salesOrder]);

  const [INcolorsCode, setINCarColorsCode] = useState([]);
  const [OUTcolorsCode, setOUTCarColorsCode] = useState([]);

  useEffect(() => {
    var currentInColor = [];
    var IN_colors = [];
    var currentOutColor = [];
    var Out_colors = [];

    var jsoncolors = {};
    try {
      colors?.forEach((item) => {
        jsoncolors[item.ColorID] = item;

        if (!currentOutColor.includes(item.ColorID?.split("/")[0])) {
          Out_colors = [
            ...Out_colors,
            { ColorDescription: item[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0], ColorID: item.ColorID?.split("/")[0], ColorImage: item?.siteOutColorImage },
          ];

          currentOutColor = [...currentOutColor, item.ColorID?.split("/")[0]];
        }

        if (!currentInColor.includes(item.ColorID?.split("/")[1])) {
          IN_colors = [
            ...IN_colors,
            { ColorDescription: item[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1], ColorID: item.ColorID?.split("/")[1], ColorImage: item?.siteInColorImage },
          ];

          currentInColor = [...currentInColor, item.ColorID?.split("/")[1]];
        }
      });

      ////console.log("IN setOUTCarColorsCode :", currentOutColor);
      setOUTCarColorsCode(currentOutColor);
      setINCarColorsCode(currentInColor);
      //---------------
    } catch (error) {
      ////console.log(error);
    }
  }, [colors]);

  useEffect(() => {
    ////console.log("useEffect setOUTCarColorsCode >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", OUTcolorsCode);

    if (activeOutColor && activeINColor) setSelectedColor(colors.filter((a) => a.ColorID == activeOutColor + "/" + activeINColor)[0]);

    if (activeOutColor && activeINColor && activeModel?.productID) {
      fetchCarDesign(activeOutColor + "/" + activeINColor, activeModel?.productID);
    }
  }, [activeINColor, activeOutColor, OUTcolorsCode]);

  useEffect(() => {
    // setActivePart(activePart);
    getActivePartSection(activePart);
  }, [outerCarImages, innerCarImages, wheels, activePart]);

  useEffect(() => {
    if (isLoadingImages == false) getActivePartSection(activePart);
  }, [isLoadingImages]);

  // to get the active part of section
  const [filterCarImages, setFilterCarImages] = useState([]);
  const getActivePartSection = async (activePart, thisSelectedColorID = selectedColor?.ColorID, Model = activeModel) => {
    // console.log("IN getActivePartSection :", activePart);
    // console.log("IN outerCarImages :", outerCarImages);
    setFilterCarImages([]);
    setActivePart(activePart);
    let result = [];

    if (activePart === 0) {
      if (outerCarImages?.length > 0) {
        result = outerCarImages;
      }
    } else if (activePart === 1) {
      if (innerCarImages?.length > 0) {
        result = innerCarImages;
      }
    } else if (activePart === 2) {
      if (wheels?.length > 0) {
        result = wheels;
      }
    }
    var allImages = [];

    try {
      allImages = outerCarImages.concat(innerCarImages ?? [], wheels ?? []);
    } catch (error) {
      allImages = outerCarImages;
    }

    //  console.log("IN allImages :", allImages);
    setFilterCarImages(allImages);
    return result;
  };

  // to reset all the state objects
  const resetValues = () => {
    setInnerCarImages([]);
    setOuterCarImages([]);
    setWheels([]);
  };

  const resetColorsValues = () => {};
  const [propsDataPass, setPropsDataPass] = useState({});
  useEffect(() => {
    var propsDataPass2 = {
      ...propsDataPass,
      vehicle: vehicle,
      isToyota: isToyota,
      isLexus: isLexus,
      selectedColor: selectedColor,
      finance: finance,
      isLoading: isLoading,
    };

    setPropsDataPass(propsDataPass2);
  }, [vehicle]);
  const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);
  const [ServiceID, setServiceID] = useState(null);
  const [allServiceID, setAllServiceID] = useState([]);
  const [Service, setService] = useState(null);
  const [serviceImportantAdditions, setServiceImportantAdditions] = useState(null);

  const [lodingService, setLodingService] = useState(false);

  return (
    <>
      {page?.toLowerCase() == "signagreement".toLowerCase() && (
        <CarCheckoutSignAgreementPage
          {...propsDataPass}
          salesOrder={salesOrder}
          parmActiveModel={activeModel}
          vehicle={vehicle}
          isToyota={isToyota}
          isLexus={isLexus}
          selectedColor={selectedColor}
          finance={finance}
          minFinance={minFinance}
          financeSettings={financeSettings}
          filterCarImages={filterCarImages}
          isLoading={isLoading}
          models={models}
          ServiceParm={Service}
        />
      )}
    </>
  );
}
